import { Attributes } from '@opentelemetry/api';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';

const isNodeRuntime = !!process.env.NEXT_RUNTIME || (typeof process === 'object' && process.release?.name === 'node');
const isJestRuntime = process.env.JEST_WORKER_ID !== undefined || process.env.NODE_ENV === 'test';
const isOtelBypass = typeof window !== 'undefined' && window.location.search.includes('disable-otel');
const isOtelEnabled = !isOtelBypass && process.env.NEXT_PUBLIC_OTEL_ENABLED === 'true';
const isOtelLogging = process.env.NEXT_PUBLIC_OTEL_LOGGING === 'true';

const tracesUrl = process.env.NEXT_PUBLIC_OTEL_TRACES_URL || 'invalid-url';
const metricsUrl = process.env.NEXT_PUBLIC_OTEL_METRICS_URL || 'invalid-url';
const appName = process.env.NEXT_PUBLIC_OTEL_CLIENT_NAME || 'invalid-app-name';
const tracesSampleRatio = Number(process.env.NEXT_PUBLIC_OTEL_TRACES_RATIO ?? 1);
const metricsIntervalMs = Number(process.env.NEXT_PUBLIC_OTEL_METRICS_INTERVAL_MS ?? 120000);

const resourceAttributes: Attributes = {
  [ATTR_SERVICE_NAME]: appName,
  lob: process.env.NEXT_PUBLIC_OTEL_LOB,
  banner: process.env.NEXT_PUBLIC_OTEL_BANNER,
  client_type: process.env.NEXT_PUBLIC_OTEL_CLIENT_TYPE,
  client_version: process.env.NEXT_PUBLIC_OTEL_CLIENT_VERSION,
  stack: 'frontend',
};

export {
  isNodeRuntime,
  isJestRuntime,
  isOtelEnabled,
  isOtelLogging,
  tracesUrl,
  metricsUrl,
  appName,
  tracesSampleRatio,
  metricsIntervalMs,
  resourceAttributes,
};
